import './polyfills.ts';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/';

// /* TODO: Internacionalizacion */
// /* Pruebas de internacionalizacion */
// import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID } from '@angular/core';
// import { TRANSLATION } from './assets/i18n/messages.es';


if (environment.production) {
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule
  // ,{ /* TODO: Internacionalizacion */
  //   providers: [
  //     { provide: TRANSLATIONS, useValue: TRANSLATION },
  //     { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
  //     { provide: LOCALE_ID, useValue: 'es' }
  //   ]
  // }
  )
    .catch(err => console.error(err));


